export const VIDEO_CALL_URL = 'clientIdentificationVideoCall';
export const VIDEO_SELFIE_URL = 'clientIdentificationUnassistedVideoCall';

export const VIDEO_CALL_INDEX = 1;
export const VIDEO_SELFIE_INDEX = 0;
